import { LandingLogoLive } from "@landing/components/landing/LandingLogoLive"
import { motion } from "framer-motion"
import { memo } from "react"

interface HeroLiveIndicatorProps {
  isPlayingSlogan: boolean
  activeSport: string | null
  computedLiveScale: number
  liveMultiplier: number
  dotBlink: boolean
  onLiveClick: () => void
}

export const HeroLiveIndicator = memo(function HeroLiveIndicator({
  isPlayingSlogan,
  activeSport,
  computedLiveScale,
  liveMultiplier,
  dotBlink,
  onLiveClick,
}: HeroLiveIndicatorProps) {
  return (
    <div className="flex items-center justify-center -mb-2 scale-[.99]">
      <button
        type="button"
        className={`rounded-full border-[0.32rem] transition-all duration-500 ease-in-out pointer-events-auto cursor-pointer focus:outline-hidden ${
          isPlayingSlogan ? (activeSport ? "animate-pulse-glow-intense" : "animate-pulse-glow-mild") : ""
        }`}
        style={{
          borderColor: "#22FF65",
          boxShadow:
            "0 0 10px rgba(34, 255, 101, 0.26), 0 0 20px rgba(34, 255, 101, 0.26), 0 0 30px rgba(34, 255, 101, 0.26)",
          WebkitBoxShadow:
            "0 0 10px rgba(34, 255, 101, 0.26), 0 0 20px rgba(34, 255, 101, 0.26), 0 0 30px rgba(34, 255, 101, 0.26)",
        }}
        onClick={onLiveClick}
      >
        <div className="flex items-center h-4 gap-[0.3rem] pl-[.9rem] pr-[1.025rem] py-[1.72rem] rounded-full text-white">
          <div className="relative">
            <motion.div
              className="w-5 h-5 rounded-full transition-all duration-500 ease-in-out"
              style={{
                backgroundColor: "#22FF65",
                opacity: 1,
                boxShadow:
                  "0 0 3px rgba(34, 255, 101, 0.74), 0 0 8px rgba(34, 255, 101, 0.74), 0 0 15px rgba(34, 255, 101, 0.74)",
                WebkitBoxShadow:
                  "0 0 3px rgba(34, 255, 101, 0.74), 0 0 8px rgba(34, 255, 101, 0.74), 0 0 15px rgba(34, 255, 101, 0.74)",
              }}
              animate={{
                scale: dotBlink ? [1, 1.3, 1] : 1,
                opacity: dotBlink ? [1, 0.7, 1] : 1,
                boxShadow: dotBlink
                  ? [
                      "0 0 3px rgba(34, 255, 101, 0.74), 0 0 8px rgba(34, 255, 101, 0.74), 0 0 15px rgba(34, 255, 101, 0.74)",
                      "0 0 8px rgba(34, 255, 101, 0.74), 0 0 15px rgba(34, 255, 101, 0.74), 0 0 25px rgba(34, 255, 101, 0.74)",
                      "0 0 3px rgba(34, 255, 101, 0.74), 0 0 8px rgba(34, 255, 101, 0.74), 0 0 15px rgba(34, 255, 101, 0.74)",
                    ]
                  : "0 0 3px rgba(34, 255, 101, 0.74), 0 0 8px rgba(34, 255, 101, 0.74), 0 0 15px rgba(34, 255, 101, 0.74)",
              }}
              transition={{
                duration: 0.4,
                ease: "easeInOut",
              }}
            />
          </div>
          <span
            className="font-bold tracking-tight mr-[.1rem] ml-[.1rem] transition-transform"
            style={{
              transform: `scale(${computedLiveScale})`,
              opacity: liveMultiplier < 1 ? 0.97 : 1,
              WebkitTransform: `scale(${computedLiveScale})`,
              transition: `transform ${liveMultiplier === 1 ? "0.35s cubic-bezier(.34,1.56,.64,1)" : "0.25s cubic-bezier(0.22,1,0.36,1)"} , opacity 0.25s ease-out`,
              WebkitTransition: `transform ${liveMultiplier === 1 ? "0.35s cubic-bezier(.34,1.56,.64,1)" : "0.25s cubic-bezier(0.22,1,0.36,1)"} , opacity 0.25s ease-out`,
              transformOrigin: "center center",
              WebkitTransformOrigin: "center center",
            }}
          >
            <LandingLogoLive className="h-[2.2rem] w-auto transition-all duration-150 ease-out group-active:opacity-90 group-active:scale-[.96]" />
          </span>
        </div>
      </button>
    </div>
  )
})
